import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { NavSidebar } from '@circuitry-ai/doc-ui';
import {
  SETTINGS_NAV_BASE,
  SETTINGS_NAV_GROUPS_RAW,
  resolveSettingsNavPath,
  type SettingsNavGroupRaw,
} from './settings-nav-config';

/** Settings menu shown only while the sidebar Settings item is hovered. */
export function SettingsNavAside({ className = '', onNavigate }: { className?: string; onNavigate?: () => void }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const currentSection = pathname.startsWith(SETTINGS_NAV_BASE)
    ? pathname.slice(SETTINGS_NAV_BASE.length).replace(/^\//, '').split('/')[0] || ''
    : '';

  const navGroups = useMemo(
    () =>
      SETTINGS_NAV_GROUPS_RAW.map((group: SettingsNavGroupRaw) => ({
        heading: t(group.headingKey),
        items: group.items.map((item) => ({
          key: item.key,
          path: resolveSettingsNavPath(item),
          label: t(item.labelKey),
          icon: item.icon,
          target: item.target,
        })),
      })),
    [t],
  );

  return (
    <NavSidebar
      className={className}
      navGroups={navGroups}
      currentSection={currentSection}
      isCollapsed={false}
      onToggleCollapse={() => undefined}
      headerTitle=""
      showHeader={false}
      variant="app"
      labelClassName="text-[14px] leading-5"
      headingClassName="px-3 pb-1.5 pt-[14px] text-xs font-bold uppercase tracking-[0.08em] text-[#a1a1aa]"
      onInternalNavigate={(path) => {
        navigate(path);
        onNavigate?.();
      }}
    />
  );
}
